import { ApiRequest, Reducer } from 'store/store';
import { initialApiRequest } from 'store/store-tools';

export const initialState: {
    categories: ApiRequest<string[]>
} = {
    categories: initialApiRequest(),
} as const;

export type CategoriesState = typeof initialState;

export const CategoriesReducer: Reducer<CategoriesState> = (state = initialState, action) => {
    switch (action.type) {
        case '@CATEGORY/FETCH_REQUEST':
            return {
                ...state,
                categories: {
                    state: 'isFetching',
                },
            };
        case '@CATEGORY/FETCH_SUCCESS':
            return {
                ...state,
                categories: {
                    state: 'valid',
                    data: action.payload,
                },
            };
        case '@CATEGORY/FETCH_FAILURE':
            return {
                ...state,
                categories: {
                    state: 'error',
                },
            };
        default:
            return state;
    }
};
